import React from 'react';
import SystemCard from './SystemCard';
import { BodyText } from '../atoms/Typography';

/**
 * Responsive grid of system cards.
 */
export default function SystemCardGrid({
  systems = [],
  onConfigure,
  onOpen,
  onTitleClick,
  onDescriptionClick,
  emptyMessage = 'No systems found.',
  className = '',
}) {
  if (!systems.length) {
    return (
      <div className={`ca-system-grid ${className}`.trim()}>
        <div className="ca-empty">
          <BodyText>{emptyMessage}</BodyText>
        </div>
      </div>
    );
  }

  return (
    <div className={`ca-system-grid ${className}`.trim()}>
      {systems.map((system) => (
        <SystemCard
          key={system.id ?? system.title}
          {...system}
          onConfigure={onConfigure}
          onOpen={onOpen}
          onTitleClick={onTitleClick}
          onDescriptionClick={onDescriptionClick}
        />
      ))}
    </div>
  );
}
